import React, {Component} from 'react';
import Aux from '../../components/Hoc/Aux';
import {scroller} from 'react-scroll';

class ScrollButton extends Component {
  render () {
    return (
      <Aux>
        <button
          onClick={() => {
            scroller.scrollTo(this.props.scrollName, this.props.scrollOpts);
          }}
          className='btn'
        >{this.props.text}</button>
      </Aux>
    );
  }
}

export default ScrollButton;


// WEBPACK FOOTER //
// ./src/components/Header/ScrollButton.jsx